// Module
var code = `<div class="h3 list-title {{classVal}}">{{title}}</div>
<p>{{title}}</p>
<ul class="docs-item-block-ul">
  {{#list}}
  <li>
    <p>{{.*}}</p>
  </li>
  {{/list}}
</ul>
`;
// Exports
module.exports = code;